module.exports = __webpack_public_path__ + "static/media/8.4a3e2b86.jpeg";